import { useRef } from 'react';
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Stack,
    Divider,
    Box,
    Center,
    Text,
    Input,
} from '@chakra-ui/react';
import { UnlockIcon, LinkIcon } from '@chakra-ui/icons';
import { QRCode } from 'react-qr-svg';

import { connect } from 'react-redux';

import DrawerMenuItem from '../drawerMenuItem/drawerMenuItem';

type CustomDrawerProps = {
    wallet?: any;
    onClose: () => void;
    isOpen: boolean;
};

const CustomDrawer = (props: CustomDrawerProps) => {
    return (
        <Drawer
            isOpen={props.isOpen}
            placement='left'
            onClose={props.onClose}
            autoFocus={false}
        >
            <DrawerOverlay>
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth='1px'>
                        BIS HUB Wallet
                    </DrawerHeader>

                    <DrawerBody>
                        {props.wallet?.address && (
                            <>
                                <Box mb={10} mt={10}>
                                    <Center>
                                        <QRCode
                                            bgColor='#FFFFFF'
                                            fgColor='#000000'
                                            level='Q'
                                            style={{ width: '60%' }}
                                            value={props.wallet?.address}
                                        />
                                    </Center>
                                </Box>
                                <Divider mb={10} />
                            </>
                        )}

                        {props.wallet ? (
                            <Stack spacing='10px'>
                                <DrawerMenuItem
                                    to='/wallet'
                                    drawerOnClose={props.onClose}
                                    text='Wallet'
                                    icon={LinkIcon}
                                />

                                {/* <Divider /> */}

                                {/* <DrawerMenuItem
                                    to='/faucet'
                                    drawerOnClose={props.onClose}
                                    text='Faucet'
                                    icon={InfoIcon}
                                /> */}

                                <DrawerMenuItem
                                    to='/privacy'
                                    drawerOnClose={props.onClose}
                                    text='Privacy'
                                    icon={UnlockIcon}
                                />
                            </Stack>
                        ) : (
                            <Box>
                                <Text>Devi prima creare un wallet</Text>
                            </Box>
                        )}
                    </DrawerBody>

                    <DrawerFooter color='blue.500'>
                        <a href='https://bis-hub.com' target='_blank'>
                            www.bis-hub.com
                        </a>
                    </DrawerFooter>
                </DrawerContent>
            </DrawerOverlay>
        </Drawer>
    );
};

const mapStateToProps = ({ wallet }: any) => {
    return {
        wallet: wallet.wallet,
        loading: wallet.loading,
    };
};

export default connect(mapStateToProps)(CustomDrawer);
